import {
  type CanvasElementOutput,
  type CanvasElementType,
  type IoConfig,
} from '@blaze-runtime/engine-domain';
import { type CanvasElementInputBinding } from '@blaze-shared/elements-domain';
import { type RuntimeEventType } from '@blaze-shared/schema-domain';

export function hasInputs(ioConfig: IoConfig | undefined): boolean {
  return (ioConfig?.inputs?.length || 0) > 0;
}

export function hasOutputs(ioConfig: IoConfig | undefined): boolean {
  return (ioConfig?.outputs?.length || 0) > 0;
}

export function hasOutputEventType(
  ioConfig: IoConfig | undefined,
  eventType: RuntimeEventType,
): boolean {
  return ioConfig?.outputs?.some((output) => output.eventType === eventType) ?? false;
}

export function getDefaultOutput(ioConfig: IoConfig | undefined): CanvasElementOutput | undefined {
  return ioConfig?.outputs?.[0];
}

export function getDefaultOutputEventType(
  ioConfig: IoConfig | undefined,
): RuntimeEventType | undefined {
  return getDefaultOutput(ioConfig)?.eventType;
}

export const getFormInputNameByType = (
  controlType?: CanvasElementType,
): CanvasElementInputBinding => {
  switch (controlType) {
    case 'checkbox':
    case 'radio':
    case 'dropdown':
    case 'tags':
      return 'selected';
    default:
      return 'value';
  }
};

export function getDataSourceInputName(elementType: CanvasElementType): CanvasElementInputBinding {
  switch (elementType) {
    case 'checkbox':
    case 'radio':
    case 'dropdown':
    case 'tags':
      return 'optionsList';
    default:
      return 'value';
  }
}
